module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pageData.total) ? _c('div', {
    staticClass: "page-style padding"
  }, [_c('span', {
    staticClass: "demonstration",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n  当前显示第 " + _vm._s(_vm.pageData.total ? _vm.pageData.start : 0) + " - " + _vm._s(_vm.pageData.page * _vm.pageData.size > _vm.pageData.total ? _vm.pageData.total : _vm.pageData.page * _vm.pageData.size) + " 条 总计" + _vm._s(_vm.pageData.total) + "条\n")]), _vm._v(" "), _c('el-pagination', {
    staticClass: "pages",
    attrs: {
      "current-page": _vm.pageData.page,
      "page-sizes": _vm.pageData.sizes || [10, 15, 20, 30, 50, 100],
      "page-size": _vm.pageData.size,
      "layout": "sizes, prev, pager, next",
      "total": _vm.pageData.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.changePage,
      "update:currentPage": function($event) {
        _vm.$set(_vm.pageData, "page", $event)
      }
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e519934","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pagination/index.vue
// module id = 617
// module chunks = 16